import { Box, Button, Paper } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ProjectPaper from "../../components/projects/ProjectPaper";
import API from "../../api/axiosConfig";

function ProjectsPage() {
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]); // Holds detailed project information
  const [loading, setLoading] = useState(true); // Initializes the loading state as true
  const [error, setError] = useState(null); // Intializes the error state as none

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        // Step 1: Fetch project IDs
        const idsResponse = await API.post("/api/users/info", {
          type: "projects",
        });

        // Declare variable in scope.
        const projectIds = idsResponse.data.info;

        // Step 2: Fetch detailed project information
        if (projectIds && projectIds.length > 0) {
          const detailsResponse = await API.post("/api/projects/details", {
            projectIds: projectIds, // Send the array of project IDs
          });

          // Step 3: Sort projects by lastUpdated value (most recent first)
          const sortedProjects = detailsResponse.data.sort(
            (b, a) => new Date(a.lastUpdated) - new Date(b.lastUpdated),
          );

          setProjects(sortedProjects); // Save sorted projects
        } else {
          // If the user has no projects, just set an empty list
          setProjects([]);
        }
      } catch (err) {
        if (err.response?.status !== 401) {
          console.error("Error:", err);
          setError("Failed to fetch projects. Please try again.");
        }
      } finally {
        setLoading(false);
      }
    };

    // CHeck for token locally first to avoid unnecessary calls
    fetchProjects();
  }, []);

  if (loading) {
    return <div>Loading projects...</div>;
  }

  if (error) {
    return (
      <Box sx={{ margin: "32px" }}>
        <h3>{error}</h3>
      </Box>
    );
  }

  return (
    <div>
      <h1>Your Projects</h1>

      {/* New Project Button */}
      <Button
        variant="contained"
        sx={{
          bgcolor: "darkred",
          "&:hover": { backgroundColor: "red" },
          marginBottom: "16px",
        }}
        onClick={() => navigate("/projects/create")}
      >
        <b>New Project</b>
      </Button>

      {projects.length > 0 ? (
        projects.map((project) => (
          <Box key={project.id}>
            <ProjectPaper proj={project} />
          </Box>
        ))
      ) : (
        <Paper
          elevation={6}
          sx={{
            variant: "outlined",
            padding: "16px",
            margin: "16px auto",
            width: 600,
          }}
        >
          <p>No projects found. Create your first!</p>
        </Paper>
      )}
    </div>
  );
}

export default ProjectsPage;
